/* src/app/jobs/pages/jobs-edit/jobs-edit.component.scss */
/*# sourceMappingURL=jobs-edit.component.css.map */
